import { Theme, createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    header1: React.CSSProperties;
    title1: React.CSSProperties;
    text1: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    header1?: React.CSSProperties;
    title1?: React.CSSProperties;
    text1?: React.CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    header1: true;
    title1: true;
    text1: true;
  }
}

// 1% = 0.16px

const theme: Theme = createTheme({
  palette: {
    mode: 'light',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1224,
      xl: 1400,
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    header1: {
      fontWeight: 700,
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '-0.32px',
    },
    title1: {
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: '-0.32px',
    },
    text1: {
      fontWeight: 450,
      fontSize: '14px',
      lineHeight: '17px',
      letterSpacing: '-0.16px',
    },
  },
});

export { theme };
